import React from 'react';
import Icon from './like.svg';

const LikeIcon = ({height='24px', width='24px', className='', color='white'}) => {
	return <Icon height={height} width={width} className={className} color={color} aria-hidden={true} />;
};

export default LikeIcon;
